import MUIFormHelperText from '@material-ui/core/FormHelperText';
import Styled from 'styled-components';
import { WIDGET_ROOT_TAG } from '../../Ids';
import { VIEWPORT_XXS_MAX } from '../../util/mediaQueries';


export const FormHelperText = Styled(MUIFormHelperText)`
  #${WIDGET_ROOT_TAG} & {
    margin-bottom: 0;
  }
`;

export const SmallH2 = Styled.h2`
#${WIDGET_ROOT_TAG} & {
  margin:0px 0px 16px 0;
  font-family: Lato, sans-serif;
  color: ${props => props.theme.headlineColor};
  font-size: 24px;
  font-weight:500;

  @media ${VIEWPORT_XXS_MAX} {
    font-size: 22px;
  }
  width:100%;
}
`;


export const MediumH2 = Styled.h2`
#${WIDGET_ROOT_TAG} & {
  margin:8px 0px;
  padding: 0px 8px;
  font-family: Lato, sans-serif;
  color: ${props => props.theme.headlineColor};
  font-size: 24px;
  font-weight:500;

  @media ${VIEWPORT_XXS_MAX} {
    font-size: 22px;
  }
  width:100%;
}
`;

export const LargeH2 = Styled.h2`
#${WIDGET_ROOT_TAG} & {
  margin:8px 0px;
  padding: 0px 8px;
  font-family: Lato, sans-serif;
  color: ${props => props.theme.headlineColor};
  font-size: 24px;
  font-weight:500;

  @media ${VIEWPORT_XXS_MAX} {
    font-size: 22px;
  }
  width:100%;
}
`;

export const PaddingBox = Styled.div`
#${WIDGET_ROOT_TAG} & {
  ${props => (props.theme.bodyShadow ? 'padding: 8px;' : '')};
}
`;
const BaseForm = Styled.form`
#${WIDGET_ROOT_TAG} & {
  width: 100%;
  border-radius:2px;
  background-color: ${props => props.theme.bodyColor};
  ${props => (props.theme.bodyShadow ? 'box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);' : '')};
  & > div {
        width:100%;
      }
}
`;
export const SmallForm = Styled(BaseForm)`
  #${WIDGET_ROOT_TAG} & {
    padding: 16px;
  }
`;

export const MediumForm = Styled(BaseForm)`
  #${WIDGET_ROOT_TAG} & {
    padding: 8px;
  }
`;

export const LargeForm = MediumForm;

export const SmallWrapper = Styled.div`
#${WIDGET_ROOT_TAG} & {
  display: flex;
  width: 100%;
  border: none;
  flex-direction: column;
  margin: 0;
  & > div  {
    flex: 1;
    width:100%;
    min-width: 220px;
    flex-grow: 1;
    padding-bottom: 16px;
    & > div{
      width:100%;
    }
  }
  & > div:last-child  {
    flex: 1;
    width:100%;
    min-width: 220px;
    flex-grow: 1;
    padding:0px;
    & > div {
      width:100%;
    }
  }
}
`;


export const MediumWrapper = Styled.div`
#${WIDGET_ROOT_TAG} & {
  display: flex;
  width: 100%;
  border: none;
  flex-direction: row;
  flex-wrap:wrap;
  & > div {
    flex: 1;
    width:100%;
    min-width: 220px;
    flex-grow: 1;
    padding: 8px;
    & > div {
      width:100%;
      & > div {
        width:100%;
      }
    }
  }
}
`;


export const LargeWrapper = Styled.div`
#${WIDGET_ROOT_TAG} & {
  display: flex;
  width: 100%;
  border: none;
  flex-direction: row;
  & > div {
    flex: 1;
    width:100%;
    min-width: 220px;
    flex-grow: 1;
    padding: 8px;
    & > div {
      width:100%;
    }
  }
}
`;
